import { CommandBarButton } from "@fluentui/react";
import React, { useContext } from "react";

import { OrderRequestListingContext } from "../../listing/context/OrderRequestListingContext";

export const ClearSelectedOrderRequestsButton: React.VFC = () => {
    const { selectedItems, setSelectedItems } = useContext(OrderRequestListingContext);

    const clear = () => {
        setSelectedItems([]);
    };

    return !selectedItems.length ? (
        <></>
    ) : (
        <CommandBarButton
            iconProps={{ iconName: "Cancel" }}
            onClick={clear}
            text={`${selectedItems.length} selected`}
        />
    );
};
